import { graphql } from "react-relay";

export const COMMIT_CONFIG_CHANGES = graphql`
  mutation CommitLineupConfigurationMutation(
    $input: CommitLineupConfigurationChangesInput!
  ) {
    commitLineupConfigurationChanges(input: $input) {
      success
    }
  }
`;
